import { Stack, Text, TextField } from '@fluentui/react';
import { useTimeAndCalendarGridConfig } from '../../hooks/useTimeAndCalendarConfig';

export const TimeAndCalendarGridConfig = () => {
    const { defaultCapacity, onChange, onBlur, error } = useTimeAndCalendarGridConfig();

    return (
        <Stack tokens={{ padding: 20, childrenGap: 16 }}>
            <Stack.Item>
                <Stack tokens={{ childrenGap: 4 }}>
                    <Text variant="xLarge">Time and Calendar Settings</Text>
                    <Text variant="medium" styles={{ root: { color: '#666666' } }}>
                        Configure default capacity and calendar settings for time tracking
                    </Text>
                </Stack>
            </Stack.Item>

            <Stack.Item>
                <TextField
                    label="Default Daily Capacity (Hours)"
                    description="Set the standard working hours per day (0-24 hours)"
                    value={defaultCapacity}
                    onChange={onChange}
                    onBlur={onBlur}
                    type="number"
                    min={0}
                    max={24}
                    step={0.5}
                    errorMessage={error}
                    styles={{
                        root: {
                            maxWidth: 300,
                        },
                        description: {
                            marginTop: 4,
                        },
                    }}
                />
            </Stack.Item>
        </Stack>
    );
};
